import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SearchableSelectComponent } from './searchable-select.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [SearchableSelectComponent],
  exports: [SearchableSelectComponent]
})
export class SearchableSelectModule {}
